import { useCallback } from 'react'

import { customerioTracker } from 'lib'
import { ZAI_SIDE_CHAT_TOGGLE_EVENT } from 'modules/zai/common/zai.consts'

import type { TZaiSideChatButtonModelReturn } from './zai-side-chat-button.types'

export const useZaiSideChatButtonModel = (): TZaiSideChatButtonModelReturn => {
  const handleClick = useCallback(() => {
    customerioTracker.track(customerioTracker.eventNames.FEATURE_USED, {
      feature: 'zai',
      action: 'open_side_chat',
    })

    window.dispatchEvent(new CustomEvent(ZAI_SIDE_CHAT_TOGGLE_EVENT))
  }, [])

  return {
    handleClick,
  }
}
